import { getPhoneNumberErrorMessage } from '../validators/phoneNumber';
import { MATCHINGS_FIELD, NAME_FIELD } from './rules';
export const validate = (values) => {
    const errors = {};
    const locationsErrors = [];
    if (values.rules) {
        values.rules.forEach((rule, ruleIndex) => {
            const matchingsErrors = [];
            const nameError = !rule.name
                ? 'Name is required'
                : '';
            rule.matchings.forEach((matchings, matchingsIndex) => {
                const matchingsError = {};
                const phoneNumberErrorMessage = getPhoneNumberErrorMessage(matchings === null || matchings === void 0 ? void 0 : matchings.match);
                if (phoneNumberErrorMessage) {
                    matchingsError.match = phoneNumberErrorMessage;
                    matchingsErrors[matchingsIndex] = matchingsError;
                }
            });
            const rulesError = Object.assign(Object.assign({}, (matchingsErrors.length && { matchings: matchingsErrors })), (nameError && { name: nameError }));
            locationsErrors[ruleIndex] = rulesError;
        });
        if (locationsErrors.length) {
            errors.rules = locationsErrors;
        }
    }
    return errors;
};
